
import { Layout } from 'antd';
import { FC } from 'react';
import {  Outlet } from 'react-router-dom';

interface Props {
  children?: JSX.Element[] | JSX.Element
}

const { Content } = Layout;


const AuthLayout: FC<Props> = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout className="auth-layout">
        <Content style={{ margin: '0 16px' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default AuthLayout;
